<template>
  <v-dialog v-model="show"
            :transition="false"
            width="686"
            content-class="dialogAlert confirm"
  >
    <v-sheet>
      <v-toolbar class="dialogAlert__header" height="120">
        <v-toolbar-title class="dialogAlert__title">
          {{ dialogTitle }}
        </v-toolbar-title>
        <v-btn icon
               width="80"
               height="88"
               class="close-btn"
               @click="$emit('confirm-close');show = false;"
        >
          <v-icon size="50">
            $close
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="dialogAlert__contents">
        <p v-html="dialogText" />
      </v-card-text>
      <v-sheet height="120" class="dialogAlert__btnWrap"
               padding="20"
      >
        <v-col cols="6">
          <v-btn color="gray"
                 height="80"
                 class="btn"
                 @click="$emit('confirm-callback')"
          >
            {{ buttonNames[0] }}
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn color="primary"
                 height="80"
                 size="m"
                 class="btn"
                 @click="$emit('confirm-cancel-callback')"
          >
            {{ buttonNames[1] }}
          </v-btn>
        </v-col>
      </v-sheet>
    </v-sheet>
  </v-dialog>
</template>

<script>
export default {
  name: 'InfoDialog',
  components: {},
  props: {
    value: { type: Boolean, default: false },
    dialogTitle: { type:String, default: null },
    dialogText: { type: String, default: null },
    buttonNames: { type: Array, default: null },
  },
  data: () => ({}),
  computed: {
    show: {
      get () {
        return this.value;
      },
      set (value) {
        this.$emit('input', value);
      },
    },
    subTitle () {
      return this.propsData.dialogText.replace("<br />")
    }
  },

  mounted() {
    // this.getSampleDate();
  },
  methods: {
    // getSampleDate () {
    //   this.$axios.get('/v2/cust/sample/count')
    //       .then(response => {
    //         if (response.data.code === 'SUCCESS') {
    //           this.reviewCount = response.data.data;
    //         }
    //       });
    // },
  }
};
</script>
<style lang="scss">
.confirm .dialogAlert {
  border-radius: 35px;
  &__header {
    .v-toolbar__content {
      border-bottom: 1px solid #dadada;
      padding-inline: 40px;
      display: flex;
      justify-content: space-between;
    }
  }
  &__title {
    font-weight: 700;
  }
  &__contents {
    text-align: center;
    padding:40px;
    font-weight: 500;
    color:#595959;
  }
  &__btnWrap {
    display: flex;
    justify-content: center;
    padding-inline: 40px;
    transform: translateY(-1px);
    background-color: #fff;
    font-size: 0;
    .btn {
      width: 100%;
      border-radius: 20px;
      color: #fff;
      font-weight: 400;
    }
  }
  .dialogAlert__contents {
    font-size: 1.1em;
    padding:40px 30px;
  }
}
</style>